import { Ref } from "@vue/composition-api";

export default function useCaptureSnapshot(
  canvasRef: Ref<HTMLCanvasElement | null>,
  videoRef: Ref<HTMLVideoElement | null>
) {
  const captureSnapshot = async (): Promise<File | null> => {
    if (!canvasRef.value || !videoRef.value || videoRef.value.readyState < 2) return null;

    const ctx = canvasRef.value.getContext("2d");
    if (!ctx) return null;

    const width = videoRef.value.videoWidth || 640;
    const height = videoRef.value.videoHeight || 480;

    canvasRef.value.width = width;
    canvasRef.value.height = height;

    ctx.clearRect(0, 0, width, height);
    ctx.drawImage(videoRef.value, 0, 0, width, height);

    return new Promise<File | null>(resolve => {
      if (!canvasRef.value) {
        resolve(null);
        return;
      }
      canvasRef.value.toBlob(
        blob => {
          if (blob) {
            const file = new File([blob], `stream-snapshot-${new Date().getTime()}.jpg`, {
              type: "image/jpeg",
            });
            resolve(file);
          } else {
            resolve(null);
          }
        },
        "image/jpeg",
        1
      );
    });
  };

  return { captureSnapshot };
}
